module.exports = __webpack_public_path__ + "static/img/8.f7e0e53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/8.png
// module id = 8PKY
// module chunks = 0